export function renderStars(rating, max = 5) {
  const value = Math.max(0, Math.min(max, Number(rating) || 0))
  const full = Math.floor(value)
  const half = value - full >= 0.5
  const stars = []
  for (let i = 1; i <= max; i += 1) {
    if (i <= full) stars.push('full')
    else if (i === full + 1 && half) stars.push('half')
    else stars.push('empty')
  }
  return stars
}

export function formatReviewDate(iso) {
  if (!iso) return ''
  try {
    return new Date(iso).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
  } catch {
    return ''
  }
}

export default function StarRating({ rating, size = 'md', showValue = false }) {
  const stars = renderStars(rating)
  return (
    <span className={`star-rating star-rating--${size}`} aria-label={`${rating} sur 5`}>
      {stars.map((type, i) => (
        <i
          key={i}
          className={
            type === 'full'
              ? 'fas fa-star star-rating__star star-rating__star--full'
              : type === 'half'
                ? 'fas fa-star-half-alt star-rating__star star-rating__star--full'
                : 'far fa-star star-rating__star star-rating__star--empty'
          }
          aria-hidden
        />
      ))}
      {showValue && rating != null && (
        <span className="star-rating__value">{Number(rating).toFixed(1)}</span>
      )}
    </span>
  )
}

export function InteractiveStarRating({ value, onChange, disabled = false }) {
  return (
    <div className="star-rating-interactive" role="group" aria-label="Choisir une note">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          className={`star-rating-interactive__btn ${value >= n ? 'is-active' : ''}`}
          onClick={() => !disabled && onChange(n)}
          disabled={disabled}
          aria-label={`${n} étoile${n > 1 ? 's' : ''}`}
        >
          <i className={value >= n ? 'fas fa-star' : 'far fa-star'} aria-hidden />
        </button>
      ))}
    </div>
  )
}
